import type { FulfillmentGeneralSettings } from '@tcr-erp/shared';
import api from './api';

export interface FulfillmentWarehouseOption {
  id: string;
  code: string;
  name: string;
  account_code: string;
}

export interface FulfillmentAccountingSettingsRow {
  store_id: string;
  store_code: string;
  store_name: string;
  purchase_in_transit_warehouse_id: string | null;
  sales_in_transit_warehouse_id: string | null;
  purchase_in_transit_warehouses: FulfillmentWarehouseOption[];
  sales_in_transit_warehouses: FulfillmentWarehouseOption[];
}

export interface FulfillmentAccountingSettingsResponse {
  success: true;
  data: FulfillmentAccountingSettingsRow[];
}

export interface FulfillmentAccountingMapping {
  store_id: string;
  purchase_in_transit_warehouse_id: string | null;
  sales_in_transit_warehouse_id: string | null;
}

export interface UpdateFulfillmentAccountingSettingsPayload {
  mappings: FulfillmentAccountingMapping[];
}

export interface FulfillmentShippingServiceOption {
  id: string;
  sku: string;
  name: string;
  state: number;
}

export interface FulfillmentShippingServiceSettings {
  shipping_service_id: string | null;
  shipping_service: FulfillmentShippingServiceOption | null;
}

export interface FulfillmentShippingServiceSettingsResponse {
  success: true;
  data: FulfillmentShippingServiceSettings;
}

export interface UpdateFulfillmentShippingServiceSettingsPayload {
  shipping_service_id: string | null;
}

export interface FulfillmentGeneralSettingsResponse {
  success: true;
  data: FulfillmentGeneralSettings;
}

export type UpdateFulfillmentGeneralSettingsPayload = FulfillmentGeneralSettings;

export const fulfillmentSettingsService = {
  getAccountingSettings: async (): Promise<FulfillmentAccountingSettingsResponse> => {
    const response = await api.get<FulfillmentAccountingSettingsResponse>('/fulfillment/settings/accounting');
    return response.data;
  },

  updateAccountingSettings: async (
    body: UpdateFulfillmentAccountingSettingsPayload,
  ): Promise<FulfillmentAccountingSettingsResponse> => {
    const response = await api.put<FulfillmentAccountingSettingsResponse>('/fulfillment/settings/accounting', body);
    return response.data;
  },

  getShippingServiceSettings: async (): Promise<FulfillmentShippingServiceSettingsResponse> => {
    const response = await api.get<FulfillmentShippingServiceSettingsResponse>('/fulfillment/settings/shipping-service');
    return response.data;
  },

  updateShippingServiceSettings: async (
    body: UpdateFulfillmentShippingServiceSettingsPayload,
  ): Promise<FulfillmentShippingServiceSettingsResponse> => {
    const response = await api.put<FulfillmentShippingServiceSettingsResponse>('/fulfillment/settings/shipping-service', body);
    return response.data;
  },

  getGeneralSettings: async (): Promise<FulfillmentGeneralSettingsResponse> => {
    const response = await api.get<FulfillmentGeneralSettingsResponse>('/fulfillment/settings/general');
    return response.data;
  },

  updateGeneralSettings: async (
    body: UpdateFulfillmentGeneralSettingsPayload,
  ): Promise<FulfillmentGeneralSettingsResponse> => {
    const response = await api.put<FulfillmentGeneralSettingsResponse>('/fulfillment/settings/general', body);
    return response.data;
  },
};
